import type { Dictionary } from "./dictionary";

export const STATUS_STRINGS: Dictionary = {
  // ---- status: operator request lifecycle ----
  "status.lifecycle.new": { de: "Neu", en: "New" },
  "status.lifecycle.in_progress": { de: "In Bearbeitung", en: "In progress" },
  "status.lifecycle.new_message": { de: "Neue Nachricht", en: "New message" },
  "status.lifecycle.answered": { de: "Beantwortet", en: "Answered" },
  "status.lifecycle.done": { de: "Erledigt", en: "Done" },

  // ---- status: response type ----
  "status.response.minimum_order_online_shop": { de: "Mindestbestellung / Onlineshop", en: "Minimum order / online shop" },
  "status.response.follow_up": { de: "Rückfrage", en: "Follow-up" },
  "status.response.information_request": { de: "Informationsanfrage", en: "Information request" },
  "status.response.handover_human": { de: "Übergabe an Mensch", en: "Handover to human" },
  "status.response.acknowledgement": { de: "Bestätigung", en: "Acknowledgement" },

  // ---- status: fact status ----
  "status.fact.unknown": { de: "Unbekannt", en: "Unknown" },
  "status.fact.extracted": { de: "Extrahiert", en: "Extracted" },
  "status.fact.confirmed": { de: "Bestätigt", en: "Confirmed" },
  "status.fact.ambiguous": { de: "Mehrdeutig", en: "Ambiguous" },
  "status.fact.conflicting": { de: "Widersprüchlich", en: "Conflicting" },
  "status.fact.externally_resolved": { de: "Extern ermittelt", en: "Externally resolved" },
  "status.fact.curated_venue_resolved": { de: "Aus dem Venue-Verzeichnis", en: "From the venue directory" },
  "status.fact.manually_overridden": { de: "Manuell überschrieben", en: "Manually overridden" },

  // ---- status: fact source ----
  "status.factSource.customer_email": { de: "Kunden-E-Mail", en: "Customer email" },
  "status.factSource.external_lookup": { de: "Externe Ermittlung", en: "External lookup" },
  "status.factSource.manual": { de: "Manuell", en: "Manual" },
  "status.factSource.rule_inference": { de: "Regel-Inferenz", en: "Rule inference" },

  // ---- status: draft review state ----
  "status.review.pending": { de: "Ausstehend", en: "Pending" },
  "status.review.edited": { de: "Bearbeitet", en: "Edited" },
  "status.review.approved": { de: "Freigegeben", en: "Approved" },
  "status.review.rejected": { de: "Abgelehnt", en: "Rejected" },

  // ---- status: send state ----
  "status.send.IDLE": { de: "Bereit", en: "Ready" },
  "status.send.SENDING": { de: "Wird gesendet", en: "Sending" },
  "status.send.SENT": { de: "Gesendet", en: "Sent" },
  "status.send.UNKNOWN": { de: "Zustellung unklar", en: "Delivery unclear" },
  "status.send.FAILED_BEFORE_SUBMISSION": { de: "Fehlgeschlagen (vor Versand)", en: "Failed (before submission)" },

  // ---- status: catering type ----
  "status.catering.fingerfood": { de: "Fingerfood", en: "Fingerfood" },
  "status.catering.menu": { de: "Menü", en: "Menu" },
  "status.catering.buffet": { de: "Buffet", en: "Buffet" },
  "status.catering.bbq": { de: "BBQ/Grill", en: "BBQ/Grill" },
  "status.catering.trade_fair": { de: "Messe", en: "Trade fair" },
  "status.catering.live_cooking": { de: "Live-Cooking", en: "Live cooking" },
  "ws.cateringTypeUnknown": { de: "Catering-Art", en: "Catering type" },

  // ---- fact field labels ----
  "field.customer.type": { de: "Kundentyp", en: "Customer type" },
  "field.customer.company_name": { de: "Firma", en: "Company" },
  "field.customer.contact_name": { de: "Ansprechpartner", en: "Contact" },
  "field.customer.email": { de: "E-Mail", en: "Email" },
  "field.customer.phone": { de: "Telefon", en: "Phone" },
  "field.customer.billing_address": { de: "Rechnungsadresse", en: "Billing address" },
  "field.event.event_name": { de: "Veranstaltungsname", en: "Event name" },
  "field.event.event_type": { de: "Anlass", en: "Occasion" },
  "field.event.dates": { de: "Datum", en: "Date" },
  "field.event.start_time": { de: "Uhrzeit", en: "Time" },
  "field.event.end_time": { de: "Endzeit", en: "End time" },
  "field.event.end_date": { de: "Enddatum", en: "End date" },
  "field.event.guest_count": { de: "Gästezahl", en: "Guest count" },
  "field.event.guest_count_qualifier": { de: "Gästezahl-Angabe", en: "Guest-count qualifier" },
  "field.event.guest_count_deferred": { de: "Gästezahl wird nachgereicht", en: "Guest count deferred" },
  "field.event.venue_name": { de: "Veranstaltungsort", en: "Venue" },
  "field.event.event_address": { de: "Veranstaltungsadresse", en: "Venue address" },
  "field.event.is_multiday": { de: "Mehrtägig", en: "Multi-day" },
  "field.event.is_outdoor": { de: "Outdoor", en: "Outdoor" },
  "field.catering.types": { de: "Catering-Art", en: "Catering type" },
  "field.catering.food_direction": { de: "Speisenrichtung", en: "Food direction" },
  "field.catering.purpose": { de: "Zweck", en: "Purpose" },
  "field.catering.sweet_requested": { de: "Süßes / Dessert", en: "Sweet / dessert" },
  "field.catering.service_form": { de: "Serviceform", en: "Service form" },
  "field.catering.course_count": { de: "Gänge", en: "Courses" },
  "field.catering.culinary_style": { de: "Kulinarische Richtung", en: "Culinary style" },
  "field.catering.drinks_from_neo": { de: "Getränke von uns", en: "Drinks from us" },
  "field.catering.service_staff_required": { de: "Servicepersonal", en: "Service staff" },
  "field.catering.tableware_required": { de: "Geschirr", en: "Tableware" },
  "field.catering.tableware_type": { de: "Geschirr-Art", en: "Tableware type" },
  "field.catering.coffee_setup": { de: "Kaffee-Setup", en: "Coffee setup" },
  "field.catering.buffet_tables_required": { de: "Buffettische", en: "Buffet tables" },
  "field.catering.budget_total_eur": { de: "Gesamtbudget (EUR)", en: "Total budget (EUR)" },
  "field.catering.dietary_requirements": { de: "Ernährung / Diät", en: "Dietary requirements" },
  "field.catering.dietary_guest_counts": { de: "Diät-Gästezahlen", en: "Dietary guest counts" },
  "field.catering.dietary_profile": { de: "Ernährungsgruppen und Einschränkungen", en: "Dietary cohorts and restrictions" },
  "field.logistics.kitchen_available": { de: "Küche / Pantry", en: "Kitchen / pantry" },
  "field.logistics.kitchen_equipment": { de: "Küchenausstattung", en: "Kitchen equipment" },
  "field.logistics.seating_type": { de: "Bestuhlung", en: "Seating arrangement" },
  "field.logistics.seating_availability": { de: "Sitzplätze", en: "Seated places" },
  "field.logistics.ground_level_delivery": { de: "Ebenerdige Anlieferung", en: "Ground-level delivery" },
  "field.logistics.elevator_available": { de: "Aufzug vorhanden", en: "Elevator available" },
  "field.logistics.elevator_suitable": { de: "Aufzug geeignet", en: "Elevator suitable" },
  "field.logistics.grill_available_on_site": { de: "Grill vor Ort", en: "Grill on site" },
  "field.logistics.grill_requested_from_neo": { de: "Grill von uns", en: "Grill from us" },
  "field.logistics.grillmaster_requested": { de: "Grillmeister", en: "Grillmaster" },
  "field.logistics.cook_requested": { de: "Koch gewünscht", en: "Cook requested" },
  "field.logistics.weather_protection_available": { de: "Wetterschutz", en: "Weather protection" },
  "field.logistics.pavilion_requested": { de: "Pavillon", en: "Pavilion" },
  "field.logistics.hall": { de: "Halle", en: "Hall" },
  "field.logistics.stand_number": { de: "Standnummer", en: "Stand number" },
  "field.logistics.stand_floors": { de: "Standetagen", en: "Stand floors" },
  "field.logistics.trade_fair_equipment": { de: "Messeausstattung", en: "Trade fair equipment" },

};
